import axios, {AxiosError} from "axios";

const ACCESS_TOKEN_ID = "ce_act";
const REFRESH_TOKEN_ID = "ce_rft";  // DEPRECATED. We don't save this anymore in localstorage.

interface RenewData {
	access: string
}

/**
 * Removes access token from localstorage.
 */
export function clearTokens() {
	localStorage.removeItem(ACCESS_TOKEN_ID);
	localStorage.removeItem(REFRESH_TOKEN_ID);  // DEPRECATED. We don't save this anymore in localstorage.
}

/**
 * Saves access token to localstorage.
 *
 * @param tokenValue - token value to save
 */
export function saveToken(tokenValue: string) {
	localStorage.setItem(ACCESS_TOKEN_ID, tokenValue);
}

/**
 * Fetches access token from local storage. Value is set to null in case it's missing.
 */
export function retrieveTokens(): { access: string | null } {
	return {
		'access': localStorage.getItem(ACCESS_TOKEN_ID),
	}
}

/**
 * Renews access token using refresh token. Since we have rotating refresh tokens enabled, server will also provide a
 * new refresh token for future use. Returns true if renewal was successful.
 *
 * @returns boolean
 */
export async function renewAccessToken(): Promise<boolean> {
	try {
			let response = await axios({
				method: "post",
				url: process.env.REACT_APP_BACKEND + "/auth/token/refresh/",
				responseType: 'json',
				withCredentials: true,
			});

			// axios treats any status code outside 2xx as error. So no need to check status code over here
			// store new refresh and access token
			saveToken((response.data as RenewData)['access']);
			return true

		} catch (err) {
			const axiosError = err as AxiosError;

			if (axiosError.response?.status === 401) {
				// Refresh token expired. Return false so we can log them out and retry login.
				clearTokens();
				return false

			} else {
				// Server Error. Return false so we can log them out and retry login.
				console.error("token renewal failed with status code " + axiosError.response?.status);
				return false
			}
		}
}
